// @flow

import type {EventRuleChange, EventRuleGroup} from '@/types'

import React, {Component} from 'react'
import {either, map, path, values} from 'ramda'

import ComplexGroup from './complex-group'
import Rule from './rule'

type Props = {
  group: EventRuleGroup,
  onChange: (EventRuleChange, check: boolean) => void,
}

const hasAllOrAny = either(
  path(['groupInfo', 'name']),
  path(['groupInfo', 'allRuleCode']),
  path(['groupInfo', 'anyRuleCode']),
)

export class RawRuleGroup extends Component<Props> {
  render = () =>
    <div className='rule-group'>
      {hasAllOrAny(this.props.group)
        ? <ComplexGroup group={this.props.group} onChange={this.props.onChange} />
        : map(
          (x) => <Rule key={x.ruleCode} rule={x} onChange={this.props.onChange} />,
          values(this.props.group.notificationRules)
        )}
    </div>
}

export default RawRuleGroup



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/rule-group.js